// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3843":"34be8fdcb3b8be51","8568":"f12f9f63a2dc4d12"}[chunkId] + ".css";
};